$ ->
	$landing = $ '.landing'
	unless $landing.length > 0
		return

	$htmlBody = $ 'html'
	$header = $ '.header'
	$primaryMenu = $ '.primary-menu'
	$secondaryMenu = $ '.secondary-menu'
	$headerPart = $ '.header, .primary-menu, .secondary-menu'

	$slides = $ '.block'
	$content = $ '.content'
	$firstBlock = $ '.block:first'
	$tourStart = $ '.tour'
	$staticImage = $ '.static-image'
	$staticLink = $ '.static-link'
	$staticCheckBox = $ '.static-checkbox'
	$fullpageDefence = $ '#fullpage_defence'
	$landingLogo = $ '.landing-logo'
	$getStarted = $ '.get-started'
	$overlay = $ '.overlay'

	firstBlockPadding = $header.height() + $primaryMenu.height() + $secondaryMenu.height()

	headerPosition = 0
	primaryMenuPosition = $header.height() + headerPosition
	secondaryMenuPosition = primaryMenuPosition + $primaryMenu.height() + 20

	$header.css 'top', headerPosition
	$primaryMenu.css 'top', primaryMenuPosition
	$secondaryMenu.css 'top', secondaryMenuPosition

	if $landing.hasClass 'fullpage'
		$firstBlock.css 'padding-top', firstBlockPadding

		$staticImage.on 'click', ->
			$.fn.fullpage.moveTo 1

		$fullpageDefence.on 'change', ->
			if @checked
				$overlay.fadeIn()
				$content.fadeIn()
			else
				$content.fadeOut()
				$overlay.fadeOut()

		$tourStart.on 'click', ->
			$.fn.fullpage.moveTo 2

		$getStarted.on 'click', ->
			$.fn.fullpage.moveTo 2

		$landingLogo.on 'click', ->
			$.fn.fullpage.moveTo 1

		$landing.fullpage
			sectionSelector: '.block'
			resize: false
			verticalCentered: false
			scrollingSpeed: 600
			navigation: false
			css3: false
			navigation: true
			fitToSection: false
			scrollBar: false
			lockAnchors: true

			onLeave: (index, nextIndex) ->
				$staticNav = $ '#fp-nav'

				if nextIndex is 1 or nextIndex is $slides.length
					if $staticLink.is(':visible') and nextIndex is $slides.length
						$staticLink.fadeOut()
					if $staticImage.is ':visible'
						$staticImage.fadeOut()
					if $staticCheckBox.is ':visible'
						$staticCheckBox.fadeOut()
					if $staticNav.is ':visible'
						$staticNav.fadeOut()

				if nextIndex isnt 1
					$headerPart.fadeOut(500)
				else
					$headerPart.fadeIn(500)

			afterLoad: (anchorLink, index) ->
				$staticNav = $ '#fp-nav'
				autoScrolling = if index is $slides.length then false else true

				if index > 1 and index isnt $slides.length
					if $staticImage.is ':hidden'
						$staticImage.fadeIn()
					if $staticLink.is ':hidden'
						$staticLink.fadeIn()
					if $staticCheckBox.is ':hidden'
						$staticCheckBox.fadeIn()
					if $staticNav.is ':hidden'
						$staticNav.fadeIn()

				$.fn.fullpage.setAutoScrolling autoScrolling
				$htmlBody.css 'height', '100%'


/** WEBPACK FOOTER **
 ** ./assets/coffee/pages/landing.coffee
 **/